<template>
  <div :class="['ms-form', { purpose: this.data?.body?.purpose }]">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <q-form v-else @submit="this.onSubmit">
      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-building" aria-hidden="true" />Основное</h3>
        <div class="ms-form-grid">
          <CustomInput
            label="Наименование"
            :required="true"
            :value="this.formData.project_name"
            @change_input="(value) => onChange('project_name', value)"
          />
          <CustomInput
            label="Короткое Наименование"
            :value="this.formData.project_short_name"
            @change_input="(value) => onChange('project_short_name', value)"
          />
          <CustomSelect
            :options="this.typeOptions"
            label="Тип проекта"
            optionValueKey="project_type_id"
            optionLabelKey="project_type_name"
            :value="this.formData.project_type_id || ''"
            @change="(value) => onChange('project_type_id', value)"
            :required="true"
            :clearable="false"
          />
          <CustomSelect
            :options="this.residencyOptions"
            label="ЖК"
            optionValueKey="resident_id"
            optionLabelKey="resident_name"
            :value="this.formData.resident_id || ''"
            @change="(value) => onChange('resident_id', value)"
            :required="true"
            :clearable="false"
          />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-calendar-days" aria-hidden="true" />Сроки и аванс</h3>
        <div class="ms-form-grid">
          <CustomDate
            :fullWidth="true"
            label="Дата начала"
            :value="this.formData.start_date"
            @change_date="(value) => onChange('start_date', value)"
            :required="true"
          />
          <CustomDate
            :fullWidth="true"
            label="Дата окончания"
            :value="this.formData.finish_date"
            @change_date="(value) => onChange('finish_date', value)"
            :required="true"
          />
          <CustomInput
            type="number"
            label="Сумма аванса"
            :value="this.formData.avans"
            @change_input="(value) => onChange('avans', value)"
          />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-link" aria-hidden="true" />Интеграции</h3>
        <div class="ms-form-grid">
          <CustomInputDropdown class="ms-form-wide" :options="projectOptions" label="Проект SBS"
            @change_input="(val) => this.projectFilterFunc(val)" optionValueKey="sbs_project_id"
            optionLabelKey="naimenovanie" :value="this.formData.sbs_project_name || ''" :loading="this.projectLoading"
            @select_item="this.projectSelectItem" />
        </div>
      </section>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomDate from "@/components/form/CustomDate";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInputDropdown from "@/components/form/CustomInputDropdown";
import { getCommonResidents } from "@/views/FastSearch/services";
import { getProjectTypes } from "@/views/ShellProjects/services";
import { putSBSProject } from "@/views/ShellProjects/services";

export default {
  name: "upd-shl-projects",
  components: { CustomInput, CustomSelect, CustomModalFooter, CustomDate, CustomInputDropdown },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      residencyOptions: [],
      typeOptions: [],
      formData: {
        project_id: this.data?.body?.project_id || "",
        project_name: this.data?.body?.project_name || "",
        project_short_name: this.data?.body?.project_short_name || "",
        project_type_id: this.data?.body?.project_type_id || "",
        resident_id: this.data?.body?.resident_id || "",
        start_date: this.data?.body?.start_date || "",
        finish_date: this.data?.body?.finish_date || "",
        avans: this.data?.body?.avans
          ? Number(this.data.body.avans.toString().replace(/\s/g, ""))
          : "",
        sbs_project_name: this.data?.body?.sbs_project_name || "",
        sbs_project_id: this.data?.body?.sbs_project_id || "",
      },
      projectOptions: [],
      projectLoading: false,
      projectSearchTimeout: null,
    };
  },
  async mounted() {
    this.isFetching = true;

    await this.getProjectTypes();
    await this.getResidentsOptions();
    this.isFetching = false;
  },
  methods: {
    projectSelectItem(value, obj) {
      this.formData = {
        ...this.formData,
        sbs_project_id: obj.sbs_project_id,
        sbs_project_name: obj.naimenovanie
      };
    },
    async projectFilterFunc(value) {
      this.formData.sbs_project_name = value;

      if (!value) {
        this.formData.sbs_project_id = '';
        this.formData.sbs_project_name = '';
        this.projectOptions = [];
        this.projectLoading = false;
        return;
      }

      if (this.projectSearchTimeout) {
        clearTimeout(this.projectSearchTimeout);
      }

      if (value?.length >= 3) {
        this.projectLoading = true;

        this.projectSearchTimeout = setTimeout(async () => {
          let body = { search_text: value }
          const response = await putSBSProject(body);
          this.projectOptions = response || [];
          this.projectLoading = false;
        }, 300);
      } else {
        this.projectOptions = [];
        this.projectLoading = false;
      }
    },
    async getProjectTypes() {
      const res = await getProjectTypes();
      this.typeOptions = res || [];
    },
    async getResidentsOptions() {
      const res = await getCommonResidents();
      this.residencyOptions = res || [];
    },
    async onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true;
      await this.data?.onSubmit(this.formData);
      this.loading = false;
    },
  },
  beforeUnmount() {
    if (this.projectSearchTimeout) {
      clearTimeout(this.projectSearchTimeout);
    }
  }
};
</script>
